// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type RecordProbationReviewOutcomeMutationVariables = Types.Exact<{
  input: Types.RecordProbationReviewOutcomeInput;
}>;

export type RecordProbationReviewOutcomeMutation = { __typename?: 'Mutation' } & {
  recordProbationReviewOutcome: { __typename?: 'RecordProbationReviewOutcomeOutput' } & Pick<
    Types.RecordProbationReviewOutcomeOutput,
    'id' | 'notificationFailed'
  >;
};

export const RecordProbationReviewOutcomeDocument = /*#__PURE__*/ gql`
    mutation RecordProbationReviewOutcome($input: RecordProbationReviewOutcomeInput!) {
  recordProbationReviewOutcome(input: $input) {
    id
    notificationFailed
  }
}
    `;
export type RecordProbationReviewOutcomeMutationFn = Apollo.MutationFunction<
  RecordProbationReviewOutcomeMutation,
  RecordProbationReviewOutcomeMutationVariables
>;

/**
 * __useRecordProbationReviewOutcomeMutation__
 *
 * To run a mutation, you first call `useRecordProbationReviewOutcomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordProbationReviewOutcomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordProbationReviewOutcomeMutation, { data, loading, error }] = useRecordProbationReviewOutcomeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordProbationReviewOutcomeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RecordProbationReviewOutcomeMutation,
    RecordProbationReviewOutcomeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RecordProbationReviewOutcomeMutation, RecordProbationReviewOutcomeMutationVariables>(
    RecordProbationReviewOutcomeDocument,
    options,
  );
}
export type RecordProbationReviewOutcomeMutationHookResult = ReturnType<typeof useRecordProbationReviewOutcomeMutation>;
export type RecordProbationReviewOutcomeMutationOptions = Apollo.BaseMutationOptions<
  RecordProbationReviewOutcomeMutation,
  RecordProbationReviewOutcomeMutationVariables
>;
